import { getDic } from '../assets/i18n/dictionary';
import { createFormControlModel } from '../models/formControlModel';

export function createGroupModel(
    id = 0,
    name = "",
) {
    const res = {
        id: id,
        name: name,
    }

    return res;
}

export function convertGroupObjectToForm(group) {
    const _form = [];

    var _index = 0;

    for (var key in group) {
        if (group.hasOwnProperty(key)) {

            var _hasForm = false;
            var _type = "text";
            var _options = null;
            var _required = true;
            var _name = "";
            var _value = group[key] ? group[key].toString() : null;

            switch (key.toString()) {
                case "id":
                    _hasForm = true;
                    _name = "id";
                    _required = true;
                    _value = parseInt(group[key]);
                    break;
                case "name":
                    _hasForm = true;
                    _name = `${getDic("nome")}`;
                    _required = true;
                    break;
                default:
                    break;
            }

            if (_hasForm) {
                const _obj = createFormControlModel(
                    _index,
                    _name,
                    _value,
                    _type,
                    null,
                    null,
                    _options, // ex => "[{\"Text\":\"Ingles \"},{\"Text\":\"Espanhol \"},{\"Text\":\"Portugues\"}]"
                    _required,
                    null,
                    null,
                    null,
                    key
                );
                _form.push(_obj);
                _index++;
            }
        }
    }
    return _form;
}

export function convertFormToGroupObject(form) {
    var _object = createGroupModel();
    form.forEach(item => {
        var _value;

        switch (item.dbReference) {
            case "id":
                _value = parseInt(item.value);
                break;
            case "name":
                _value = item.value;
                break;
            default:
                break;
        }
        _object[item.dbReference] = _value;
    });
    return _object;
}
